<template>
  <div class="row">
    <div class="col-xl-12">
      <!-- begin: Child Route View -->
      <router-view />
      <!-- end: Child Route View -->

      <div v-show="isHubRoute" class="kt-portlet kt-portlet--mobile">
        <div class="kt-portlet__head kt-portlet__head--lg">
          <div class="kt-portlet__head-label">
            <span class="kt-portlet__head-icon">
              <i class="fas fa-chart-line"></i>
            </span>
            <h3 class="kt-portlet__head-title">Monitoring</h3>
          </div>
        </div>
        <div class="kt-portlet__body">
          <div class="row">
            <div class="col-xl-3 col-md-6 mb-4" v-for="card in cards" :key="card.path">
              <router-link :to="card.path" class="monitoring-card-link">
                <div class="kt-portlet kt-portlet--height-fluid monitoring-card">
                  <div class="kt-portlet__body text-center">
                    <div class="monitoring-card-icon mb-3">
                      <i :class="card.icon"></i>
                    </div>
                    <h4 class="monitoring-card-title">{{ card.title }}</h4>
                    <p class="monitoring-card-desc text-muted mb-0">{{ card.description }}</p>
                  </div>
                </div>
              </router-link>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "MonitoringHub",
  computed: {
    isHubRoute() {
      return this.$route.path.toLowerCase() === "/monitoring";
    },
  },
  data() {
    return {
      cards: [
        {
          path: "/Monitoring/ScheduledJobs",
          icon: "fas fa-clock fa-3x text-primary",
          title: "Scheduled Jobs",
          description: "สถานะงาน cron/SQL ทั้งหมด + log history + toggle แจ้งเตือน",
        },
        {
          path: "/Monitoring/SendEmailReportAgent",
          icon: "fas fa-envelope fa-3x text-info",
          title: "Send Email Report Agent",
          description: "ดู log + manual trigger การส่งอีเมลรายงานตัวแทน",
        },
        {
          path: "/Monitoring/SCVD",
          icon: "fas fa-box-open fa-3x text-success",
          title: "Stock Cover Days",
          description: "รัน Backfill / Close Period ด้วยตนเอง + ดูสถานะ Period",
        },
        {
          path: "/Monitoring/ClearImage",
          icon: "fas fa-images fa-3x text-warning",
          title: "Clear PM Image",
          description: "ลบรูปล้างเครื่อง PM บน GCS (เก็บ 12 รอบล่าสุด) — Preview / Mark / Sweep / Purge",
        },
      ],
    };
  },
};
</script>

<style scoped>
.monitoring-card-link {
  display: block;
  text-decoration: none;
  color: inherit;
}
.monitoring-card-link:hover {
  text-decoration: none;
}
.monitoring-card {
  cursor: pointer;
  transition: transform 0.15s ease, box-shadow 0.15s ease;
  border: 1px solid #ebedf2;
}
.monitoring-card:hover {
  transform: translateY(-3px);
  box-shadow: 0 0.5rem 1rem rgba(0, 0, 0, 0.1);
  border-color: #5867dd;
}
.monitoring-card-icon {
  padding-top: 10px;
}
.monitoring-card-title {
  font-weight: 500;
  color: #48465b;
}
.monitoring-card-desc {
  font-size: 0.9rem;
}
</style>



// WEBPACK FOOTER //
// App/Components/Monitoring/MonitoringHub.vue